/*
  Project: Vivafloors
  Author: Thomas
 */

// Bootstrap
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/collapse';

// Lazysizes
import 'lazysizes';

// Polyfills for IE11
import 'picturefill';
import './vendor/mouseEvent';

// import './modules/animate';
import './modules/dealers/init';
import './modules/menu';
import './modules/tabs';
import './modules/favoriteModal';
import './modules/tip';
import './modules/checkout';
import './modules/checkoutSteps';
import './modules/bundles';
import './modules/heroVideo';
import './modules/coupon';
import './modules/history';
import './modules/floornumbers';
import './modules/eventTracking';
import './modules/reposition';
import './modules/hoverImage';
import './modules/languageSwither';
import './modules/strikeThrough';
import './modules/excel-converter';
import './modules/cookiebot';
import './modules/show-more';

// Blocks
import './blocks/swiper';

import '@fancyapps/fancybox';
jQuery().fancybox();



// WEBPACK FOOTER //
// ./src/scripts/app.js